module.exports = __webpack_public_path__ + "components/flag/static/square/jo-6bb32ebc7bb7d4c40b221c62ab59d1a2.svg";